<template>
    <v-col cols="12" class="">
        <v-row>
            <v-col cols="12" justify="center" align="center" class="custom-card">
                <v-card
                    class="px-md-2 px-lg-4 py-0 py-lg-4"
                    elevation="0"
                >
                    <v-row align="center" justify="center" class="px-sm-3">
                        <v-col cols="12" align="start" class="px-0 pt-lg-0 headers-text">
                            <p class="mb-0">
                                <strong>{{ $t('profile.accumulated_items') }}</strong>
                            </p>
                            <small class="mb-0">{{ $t('profile.subtitle_accumulated_items') }}</small>
                        </v-col>
                        <v-row class="ma-0 py-3 wrap-items" >
                            <v-col data-cy="profile-coins-data" cols="4" md="3" offset="2" offset-md="3" class="pa-0">
                                <v-img 
                                    :src="require('@/assets/img/icons/beecoins.png')"
                                    :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?58:85"
                                    :width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?58:85">
                                </v-img>
                                <p class="text-center color-text mt-1">
                                    <strong class="d-block">{{ userData.coins }}</strong>
                                    <span>BeeCoins</span>
                                </p>
                            </v-col>
                            <v-col data-cy="profile-cumulative_xp-data" cols="4" md="3" class="pa-0">
                                <v-img 
                                    :src="require('@/assets/img/icons/xp-coin.png')"
                                    :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?58:85"
                                    :width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?58:85">
                                </v-img>
                                <p class="text-center color-text mt-1">
                                    <strong class="d-block">{{ userData.points }}</strong>
                                    <span>{{ $t('profile.cumulative_xp') }}</span>
                                </p>
                            </v-col>
                        </v-row>
                        <!-- <v-col cols="6" lg="4" order="3" class="pa-0 text-h5 font-weight-regular color-primary">
                            <vue-ellipse-progress
                                :progress="userData.advancePercent"
                                :size="120"
                                :legend="false"
                                emptyColor="#816AD6"
                                :color="gradient"
                                thickness="10"
                                emptyThickness="10"
                                dot="25 #FFB600"
                                class="text-h5"
                            >
                            <div slot="legend-caption" class="text-h4">
                                {{ userData.level }}
                            </div>
                            </vue-ellipse-progress>
                            <p class="text-center color-text">
                                {{ $t('profile.level') }} {{ userData.level }}
                            </p>
                        </v-col> -->
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            userData: (state) => state.userData
        }),
    },
    data() {
        return {
            gradient: {
                radial: false,
                colors: [
                    {
                        color: '#FFDA00',
                        offset: '0',
                        opacity: '1'
                    },
                    {
                        color: '#FFC400',
                        offset: '100',
                        opacity: '1'
                    }
                ]
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.color-primary {
    color: #816AD6;
}
.color-text {
    color: #323A46;
    font-size: 1em;
    font-weight: 700;
    line-height: 100%;
    span{
        font-size: .95em;
        font-weight: 400;
    }
}
.v-card {
    border-radius: 20px;
}
.wrap-items{
    background: linear-gradient(111.92deg, rgba(254, 246, 231, 0.5) 4.03%, rgba(254, 246, 231, 0.5) 36.12%, rgba(238, 236, 248, 0.5) 55.82%);
    box-shadow: 0px 0px 16px 0px #C3BEDD1F inset;
    @media screen and (max-width: 599px){
        border-radius: 12px;
    }
}
</style>